import styled from 'styled-components'

export const Container = styled.div`
    display:flex;
    flex-direction: column;
    margin: 0;
    width: 100%;
    padding: 0 10px;
    @media (min-width: 768px) { 
        width: 100%;
        padding: 0 10px;
    }
    @media (min-width: 992px) { 
        width: 100%;
        padding: 0 145px;
    }
    @media (min-width: 1200px) { 
        width: 100%;
        padding: 0 145px;
    }
`
export const Navigation = styled.div`
    display:flex;
    flex-direction: row;
    margin: 50px 0 20px 0;
    width: 100%;
    padding: 10px;
    align-items: center;
    justify-content: flex-end;
    @media (min-width: 768px) { 
      padding: 10px;
    }
    @media (min-width: 992px) { 
      padding: 20px;
    }
    @media (min-width: 1200px) { 
      padding: 30px;
    }
`

export const Itemnavigate = styled.div`
   display: flex;
   flex-direction: row;
   align-items: center;
   margin-left:20px;
   color:#4D4F5C;
`

export const Active = styled.div`
   display:flex;
   flex-direction: column;
   background: #00B700;
   color: #fff;
   width: 60px;
   border-radius: 30px;
   justify-content: center;
   align-items: flex-end;
   display: flex;
   font-size: 28px; 
   margin-left:10px;
   cursor: pointer;
    svg{
       color:#fff;
    }
   
`

export const Icon = styled.div`
   display:flex;
   flex-direction: column;
   background: #00B700;
   color: #fff;
   border-radius: 30px;
   justify-content: center;
   align-items: center;
   padding:3px;
   display: flex;
   font-size: 28px; 
   margin-left:10px;
   cursor: pointer;
    svg{
       color:#fff;
    }
   
`


export const Inactive = styled.div`
   display:flex;
   flex-direction: column;
   background: #00000040;
   color: #fff;
   width: 60px;
   border-radius: 30px;
   justify-content: center;
   align-items: flex-start;
   display: flex;
   font-size: 28px; 
   margin-left:10px;
   cursor: pointer;
    svg{
       color:#fff;
    }
`

export const Item = styled.div`
    display:flex;
    flex-direction: column;
    margin: 10px 0;
    width: 100%;
    padding: 10px;
    color: #fff;
    background: #2158A4;
    box-shadow: 0px 4px 10px #00000040;
    @media (min-width: 768px) { 
      padding: 10px;
    }
    @media (min-width: 992px) { 
      padding: 20px;
    }
    @media (min-width: 1200px) { 
      padding: 30px;
    }
`

export const Col = styled.div`
    display: flex;
    margin: 20px 0;
    justify-content: space-around;
    align-items: center;
    @media (min-width: 768px) { 

    }
    @media (min-width: 992px) { 

    }
    @media (min-width: 1200px) { 

    }
`

export const FormContainer = styled.div`
    text-align: center;
    margin: 50px 0;
    height: 100vh;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    background: rgba(255,255,255,.9);
    @media (min-width: 768px) { 
      margin: 50px 0;
        height: 100vh;
    }
    @media (min-width: 992px) { 
      margin: 50px 0;
        height: auto;
    }
    @media (min-width: 1200px) { 
      margin: 50px 0;
        height: auto;
    }
`

export const Form = styled.form`
   display: flex;
   flex-direction: column;
`

export const MesssageLogin = styled.div`
   margin-bottom:50px;
`
export const Name = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`

export const BtnFlag = styled.div`
  cursor:pointer;
`


export const LoginNotice = styled.div`
    color:#f33;
    font-size:12px;
    margin-bottom:20px;
    margin-top:20px;
`

export const Textarea = styled.textarea`
    width:100%;
    padding: 20px;
`

export const Btnpreguntar = styled.div`
    background: #D9A76A;
    color: #fff;
    margin-left: 0px;
    border-radius: 4px;
    border: #D9A76A solid 1px;
    display: inline-flex;
    text-transform: uppercase;
    cursor: pointer;
    margin-top:10px;
    margin-bottom:10px;
    margin-right: 13px;
    font-size: 12px;
    padding: 4px 8px;

    &:hover{
        opacity:.8;
    }
`

export const Hr = styled.hr`
    width: 100%;
    margin: 50px 0;
`
export const Select = styled.hr`
   border: #ccc solid 1px;
  padding: 5px 20px;
  margin: 0;
  margin-bottom: 10px;
  font-size: 12px;
`
